import { useEffect, useState } from 'react';
import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks
} from 'body-scroll-lock';

const useScrollLock = (ref) => {
    const [isLocked, setIsLocked] = useState(null);

    useEffect(() => {
        if (isLocked === null) return;

        if (ref && ref.current) {
            if (isLocked) {
                disableBodyScroll(ref.current);
            } else {
                enableBodyScroll(ref.current);
            }
        }

        return () => {
            clearAllBodyScrollLocks();
        };
    }, [ref, isLocked]);

    return {
        isLocked,
        setIsLocked
    };
};

export default useScrollLock;
